import {
  DateForm as DateFormQnr,
  QuestionnaireFormProps,
  QuestionnaireQuestions,
} from '@getpopsure/qnr-framework';
import { ManipulateType } from 'dayjs';
import { useSafeTranslation } from 'shared/i18n';

export type DateOperation =
  | {
      op: 'add';
      value: number;
      type: ManipulateType;
    }
  | {
      op: 'subtract';
      value: number;
      type: ManipulateType;
    };

type DateFormProps<Questionnaire extends QuestionnaireQuestions> = {
  yearRange:
    | { min: number; max: number }
    | { min: DateOperation; max: DateOperation };
  displayCalendar?: boolean;
  placeholders?: {
    day?: string;
    month?: string;
    year?: string;
    error?: string;
    errorAfterMaxYear?: string;
    errorBeforeMinYear?: string;
  };
  dayjsLocale?: ILocale;
  firstDayOfWeek?: number;
} & QuestionnaireFormProps<Questionnaire, string>;

export const DateForm = <Questionnaire extends QuestionnaireQuestions>({
  value,
  ...rest
}: DateFormProps<Questionnaire>) => {
  const { t } = useSafeTranslation();

  return (
    <DateFormQnr
      {...rest}
      value={value as string | undefined}
      placeholders={{
        day: t('qnrf.forms.date.day.placeholder', 'Day'),
        month: t('qnrf.forms.date.month.placeholder', 'Month'),
        year: t('qnrf.forms.date.year.placeholder', 'Year'),
      }}
    />
  );
};
